import React from 'react';
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import {
  Routes,
  Route
} from 'react-router-dom';

import IndexPage from './pages/Index.js';
import ImpressumPage from './pages/Impressum.js';
import KontaktPage from './pages/Kontakt.js';
import RechnungValidierenPage from './pages/Rechnung-validieren.js';
import RechnungEmpfangenPage from './pages/Rechnung-empfangen.js';

function App() {
  return (
  <div>
    <Routes>
      <Route path="/" element={<IndexPage />} />
         
      <Route path="/impressum" element={<ImpressumPage />} />
         
      <Route path="/kontakt" element={<KontaktPage />} />
         
      <Route path="/rechnungvalidieren" element={<RechnungValidierenPage />} />
         
      <Route path="/rechnungempfangen" element={<RechnungEmpfangenPage />} />
    </Routes>
    <CookieConsent
    location="bottom"
    buttonText="Okay"
    cookieName="myAwesomeCookieName2"
    style={{ background: "#2B373B" }}
    buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
    expires={150}
    onAccept={() => {
      var _mtm = (window._mtm = window._mtm || []);
      _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
      var d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
      g.async = true;
      g.src = "https://cdn.matomo.cloud/deckl.matomo.cloud/container_Exn2KYvN.js";
      s.parentNode.insertBefore(g, s);

      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "q0lvg0hpbh");

      console.log("Matomo script executed after consent.");              
    }}
  >
    This website uses cookies to enhance the user experience.
  </CookieConsent>
  </div>
  );
}

export default App;
